<template>
  <div class="app-wrapper">
    <!-- 侧边栏 -->
    <aside class="sidebar" :class="{ 'is-collapsed': isCollapsed }">
      <div class="logo">
        <i class="el-icon-food"></i>
        <span v-show="!isCollapsed">爱心食物银行</span>
      </div>
      <el-menu
        :default-active="$route.path"
        :collapse="isCollapsed"
        router
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        class="sidebar-menu"
      >
        <el-menu-item index="/dashboard">
          <i class="el-icon-data-line"></i>
          <span slot="title">工作台</span>
        </el-menu-item>

        <el-submenu index="community">
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>社区管理</span>
          </template>
          <el-menu-item index="/community/list">社区列表</el-menu-item>
          <el-menu-item index="/community/staff">工作人员管理</el-menu-item>
        </el-submenu>

        <el-submenu index="merchant">
          <template slot="title">
            <i class="el-icon-s-shop"></i>
            <span>商户管理</span>
          </template>
          <el-menu-item index="/merchant/list">商户审核列表</el-menu-item>
          <el-menu-item index="/merchant/merchantStaff">商户人员管理</el-menu-item>
        </el-submenu>

        <el-submenu index="product">
          <template slot="title">
            <i class="el-icon-s-goods"></i>
            <span>商品管理</span>
          </template>
          <el-menu-item index="/product/list">商品列表</el-menu-item>
        </el-submenu>

        <el-submenu index="order">
          <template slot="title">
            <i class="el-icon-s-order"></i>
            <span>订单管理</span>
          </template>
          <el-menu-item index="/order/list">订单列表</el-menu-item>
          <el-menu-item index="/order/verify-log">核销记录</el-menu-item>
        </el-submenu>
        <el-submenu index="banner">
          <template slot="title">
            <i class="el-icon-s-goods"></i>
            <span>运营位管理</span>
          </template>
          <el-menu-item index="/banner/list">运营位列表</el-menu-item>
        </el-submenu>

        <el-submenu index="user">
          <template slot="title">
            <i class="el-icon-user-solid"></i>
            <span>用户管理</span>
          </template>
          <el-menu-item index="/user/list">用户列表</el-menu-item>
          <el-menu-item index="/user/verification">实名认证审核</el-menu-item>
        </el-submenu>

        <el-menu-item index="/whitelist/list">
          <i class="el-icon-s-check"></i>
          <span slot="title">白名单管理</span>
        </el-menu-item>

<!--        <el-menu-item index="/notification/list">-->
<!--          <i class="el-icon-message"></i>-->
<!--          <span slot="title">消息推送</span>-->
<!--        </el-menu-item>-->
      </el-menu>
    </aside>

    <!-- 主区域 -->
    <div class="main-container" :class="{ 'is-collapsed': isCollapsed }">
      <!-- 顶部导航 -->
      <header class="navbar">
        <div class="left">
          <i
            :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            class="toggle-btn"
            @click="toggleSidebar"
          ></i>
        </div>
        <div class="right">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="user-info">
              <i class="el-icon-user-solid"></i>
              {{ userInfo.name || userInfo.account || '管理员' }}
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="changePassword">
                <i class="el-icon-lock"></i> 修改密码
              </el-dropdown-item>
              <el-dropdown-item command="logout" divided>
                <i class="el-icon-switch-button"></i> 退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>

      <!-- 面包屑 -->
      <div class="breadcrumb-wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.meta.title">{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 内容区 -->
      <main class="app-main">
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </main>
    </div>


    <!-- 修改密码弹窗 -->
    <change-password
        :visible.sync="changePwdVisible"
    />
  </div>

</template>


<script>
import { mapState, mapActions } from 'vuex'
import ChangePassword from '@/components/ChangePassword.vue'

export default {
  name: 'Layout',
  components: {
    ChangePassword   // ✅ 新增
  },
  data() {
    return {
      isCollapsed: false,
      changePwdVisible: false
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapActions(['logout']),
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
    },
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$confirm('确认退出登录吗？', '提示', { type: 'warning' })
          .then(() => {
            this.logout()
            this.$router.push('/login')
            this.$message.success('已退出登录')
          })
          .catch(() => {})
      }
      // ✅ 新增：打开修改密码弹窗
      if (cmd === 'changePassword') {
        this.changePwdVisible = true
      }
    }
  }
}
</script>

<style scoped>
.app-wrapper {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

/* 侧边栏 */
.sidebar {
  width: 220px;
  height: 100%;
  background: #304156;
  transition: width 0.3s;
  overflow-y: auto;
  overflow-x: hidden;
  flex-shrink: 0;
}
.sidebar.is-collapsed {
  width: 64px;
}
.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  background: #2b3a4a;
  white-space: nowrap;
}
.logo i {
  font-size: 24px;
  margin-right: 8px;
  color: #409EFF;
}
.sidebar-menu {
  border-right: none;
}
.sidebar-menu:not(.el-menu--collapse) {
  width: 220px;
}

/* 主区域 */
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  overflow: hidden;
  transition: margin-left 0.3s;
}

/* 顶部导航 */
.navbar {
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.toggle-btn {
  font-size: 22px;
  cursor: pointer;
  color: #5a5e66;
}
.toggle-btn:hover {
  color: #409EFF;
}
.user-info {
  cursor: pointer;
  font-size: 14px;
  color: #5a5e66;
  display: flex;
  align-items: center;
  gap: 6px;
}
.user-info:hover {
  color: #409EFF;
}

/* 面包屑 */
.breadcrumb-wrap {
  padding: 12px 20px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

/* 内容区 */
.app-main {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #f0f2f5;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
